import React from 'react';
import PropTypes from 'prop-types';
import { StatusAvailableIconSVG, StatusOfflineIconSVG, StatusBusyIconSVG } from 's2s-svg-icons';
import styled from 'styled-components';
import { colorGrid } from 's2s-themes';
import { getIntlText } from '../js/utilities';

const ContactStatusArea = styled.div`
  align-items : center;
  display: flex;
  font-size: 12px;
`;


const StatusMessageArea = styled.div`
  font-family: "Open Sans";
  color: #ffffff;
  text-transform: uppercase;
  display : block;
  order: ${props => props.iconPosition === "left" ? '2' : '1'};
  width: 64px;
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ContactStatus = (props) => {
  let statusMsg;

  if (props.isMsgDisplayed) {
    if (props.customStatusMsg !== '') {
      statusMsg = props.customStatusMsg;
    } else {
      switch (props.status.toLowerCase()) {
        case 'available':
          statusMsg = getIntlText(props.intl, 'CONTACTS-STATUS-AVAILABLE', 'Available');
          break;
        case 'active':
          statusMsg = getIntlText(props.intl, 'CONTACTS-STATUS-ACTIVE', 'Active');
          break;
        case 'online':
        case 'connected':
          statusMsg = getIntlText(props.intl, 'CONTACTS-STATUS-ONLINE', 'Online');
          break;
        case 'offline':
        case 'not connected':
          statusMsg = getIntlText(props.intl, 'CONTACTS-STATUS-OFFLINE', 'Offline');
          break;
        case 'busy':
          statusMsg = getIntlText(props.intl, 'CONTACTS-STATUS-BUSY', 'Busy');
          break;
        case 'unknown':
          statusMsg = getIntlText(props.intl, 'CONTACTS-STATUS-UNKNOWN', 'Unknown');
          break;

        default:
          statusMsg = getIntlText(props.intl, 'CONTACTS-STATUS-UNKNOWN', 'Unknown');
      }
    }
  }

  let DisplayedSVG;

  if (props.isIconDisplayed) {
    switch (props.status.toLowerCase()) {
      case 'available':
      case 'online':
      case 'connected':
      case 'active':
        DisplayedSVG = (
          <StatusAvailableIconSVG
            className="OnlineSVG"
            svgStyle={{
              marginTop: '0px',
              marginRight: '5px',
              marginBottom: '0px',
              marginLeft: '5px',
              height: '40px',
              width: '40px',
              fill: colorGrid.green9,
              order: props.iconPosition === 'left' ? '1' : '2',
              alignSelf: 'center',
              flexDirection: 'column'
            }}
          />);
        break;
      case 'offline':
      case 'not connected':
        DisplayedSVG = (
          <StatusOfflineIconSVG
            className="OfflineSVG"
            svgStyle={{
              alignSelf: 'center',
              fill: colorGrid.gray0,
              height: '40px',
              margin: '0px 5px',
              width: '40px',
              order: props.iconPosition === 'left' ? '1' : '2',
              flexDirection: 'column'
            }}
          />);
        break;
      case 'busy':
        DisplayedSVG = (
          <StatusBusyIconSVG
            className="BusySVG"
            svgStyle={{
              alignSelf: 'center',
              fill: colorGrid.red3,
              flexDirection: 'column',
              margin: '0px 5px',
              height: '40px',
              order: this.props.iconPosition === 'left' ? '1' : '2',
              width: '40px'
            }}
          />);
        break;
      case 'unknown':
        DisplayedSVG = undefined;
        break;

      default:
        DisplayedSVG = undefined;
        break;

    }
  }

  const StatusMessage = (
    <StatusMessageArea
      className="StatusMessageArea"
      status={props.status}
      isMsgDisplayed={props.isMsgDisplayed}
      iconPosition={props.iconPosition}
    >
      {statusMsg}
    </StatusMessageArea>
  );

  let childrenPosition = (
    <React.Fragment>
      {StatusMessage}
      {DisplayedSVG}
    </React.Fragment>
  );

  if (props.iconPosition === "left") {
    childrenPosition = (
      <React.Fragment>
        {DisplayedSVG}
        {StatusMessage}
      </React.Fragment>
    );
  }
  return (
    <ContactStatusArea className="ContactStatusArea">
      {childrenPosition}
    </ContactStatusArea>
  );
};


ContactStatus.propTypes = {
  customStatusMsg: PropTypes.string,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  isIconDisplayed: PropTypes.bool,
  isMsgDisplayed: PropTypes.bool,
  status: PropTypes.string,
  intl: PropTypes.object
};

ContactStatus.defaultProps = {
  customStatusMsg: '',
  iconPosition: 'right',
  isIconDisplayed: true,
  isMsgDisplayed: true,
  status: 'unknown'
};



export default ContactStatus;
